// extracted by mini-css-extract-plugin
export default {"appraise":"appraise_appraise__1WGUZ","appraiseBox":"appraise_appraiseBox__lv5Yk","leftBox":"appraise_leftBox__w2oJ4","rightBox":"appraise_rightBox__iTIJB"};